import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Debts = () => {
  const [debts, setDebts] = useState([]);
  const [overdueDebts, setOverdueDebts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [showExtendModal, setShowExtendModal] = useState(false);
  const [showExtensionsModal, setShowExtensionsModal] = useState(false);
  const [selectedDebt, setSelectedDebt] = useState(null);
  const [extensions, setExtensions] = useState([]);
  const [payForm, setPayForm] = useState({ amount: '', notes: '' });
  const [extendForm, setExtendForm] = useState({ new_due_date: '', notes: '' });
  const [loading, setLoading] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCurrency, setFilterCurrency] = useState('all');
  const [form, setForm] = useState({
    customer_id: '', amount: '', currency: 'USD',
    type: 'receivable', due_date: '', notes: ''
  });
  const token = localStorage.getItem('token');
  const currencyList = ['IQD', 'USD', 'EUR', 'GBP', 'SAR', 'AED', 'TRY', 'CAD'];

  useEffect(() => {
    fetchDebts();
    fetchOverdueDebts();
    fetchCustomers();
  }, []);

  const fetchDebts = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/debts', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDebts(response.data.debts);
    } catch (err) { console.error(err); }
  };

  const fetchOverdueDebts = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/debts/overdue', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOverdueDebts(response.data.debts || []);
    } catch (err) { console.error(err); }
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(response.data.customers);
    } catch (err) { console.error(err); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/debts', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setShowForm(false);
      setForm({ customer_id: '', amount: '', currency: 'USD', type: 'receivable', due_date: '', notes: '' });
      fetchDebts();
      fetchOverdueDebts();
      alert('تم إضافة المديونية بنجاح!');
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const openPayModal = (debt) => {
    setSelectedDebt(debt);
    setPayForm({ amount: '', notes: '' });
    setShowPayModal(true);
  };

  const openExtendModal = (debt) => {
    setSelectedDebt(debt);
    setExtendForm({ new_due_date: '', notes: '' });
    setShowExtendModal(true);
  };

  const openExtensionsModal = async (debt) => {
    setSelectedDebt(debt);
    try {
      const res = await axios.get(`https://app.hayahost.net/api/debts/${debt.id}/extensions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setExtensions(res.data.extensions);
      setShowExtensionsModal(true);
    } catch (err) { console.error(err); }
  };

  const handlePay = async (e) => {
    e.preventDefault();
    if (!payForm.amount) return alert('أدخل المبلغ');
    setLoading(true);
    try {
      await axios.put(`https://app.hayahost.net/api/debts/${selectedDebt.id}/pay`,
        { amount: payForm.amount, notes: payForm.notes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowPayModal(false);
      setSelectedDebt(null);
      setPayForm({ amount: '', notes: '' });
      fetchDebts();
      fetchOverdueDebts();
      alert('تم تسديد المديونية بنجاح!');
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في التسديد');
    }
    setLoading(false);
  };

  const handleExtend = async (e) => {
    e.preventDefault();
    if (!extendForm.new_due_date) return alert('أدخل التاريخ الجديد');
    setLoading(true);
    try {
      const res = await axios.put(`https://app.hayahost.net/api/debts/${selectedDebt.id}/extend`,
        extendForm,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowExtendModal(false);
      setSelectedDebt(null);
      setExtendForm({ new_due_date: '', notes: '' });
      fetchDebts();
      fetchOverdueDebts();
      alert(res.data.message);
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في التمديد');
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل تريد حذف هذه المديونية؟')) return;
    try {
      await axios.delete(`https://app.hayahost.net/api/debts/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchDebts();
      fetchOverdueDebts();
    } catch (err) { console.error(err); }
  };

  const downloadCustomerDebtPDF = async (customerId, customerName) => {
    setLoadingPDF(true);
    try {
      const response = await axios.get(
        `https://app.hayahost.net/api/pdf/customer-report/${customerId}`,
        { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `كشف_ديون_${customerName}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) { alert('خطأ في تحميل PDF'); }
    setLoadingPDF(false);
  };

  const handlePrint = () => { window.print(); };

  const getStatusText = (status) => {
    switch(status) {
      case 'paid': return { text: 'مسدد', color: '#2e7d32', bg: '#e8f5e9' };
      case 'partial': return { text: 'جزئي', color: '#e65100', bg: '#fff3e0' };
      default: return { text: 'معلق', color: '#c62828', bg: '#ffebee' };
    }
  };

  const getTypeText = (type) => {
    return type === 'payable' ? { text: '📤 علينا', color: '#c62828' } : { text: '📥 لنا', color: '#2e7d32' };
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const filteredDebts = debts.filter(d => {
    if (filterType !== 'all' && d.debt_type !== filterType) return false;
    if (filterStatus !== 'all' && d.status !== filterStatus) return false;
    if (filterCurrency !== 'all' && d.currency !== filterCurrency) return false;
    if (search) {
      const s = search.toLowerCase();
      return (
        d.customer_name?.toLowerCase().includes(s) ||
        d.notes?.toLowerCase().includes(s) ||
        d.currency?.toLowerCase().includes(s) ||
        String(d.amount).includes(s)
      );
    }
    return true;
  });

  const totalReceivable = debts.filter(d => d.debt_type === 'receivable' && d.status !== 'paid').reduce((s, d) => s + parseFloat(d.remaining_amount || d.amount), 0);
  const totalPayable = debts.filter(d => d.debt_type === 'payable' && d.status !== 'paid').reduce((s, d) => s + parseFloat(d.remaining_amount || d.amount), 0);

  // يظهر الملخص فقط إذا كانت النتائج لعميل واحد
  const uniqueCustomers = [...new Set(filteredDebts.map(d => d.customer_id))];
  const isSingleCustomer = search.trim() && uniqueCustomers.length === 1;
  const customerDebts = isSingleCustomer ? filteredDebts : [];

  const customerSummary = customerDebts.length > 0 ? {
    name: customerDebts[0].customer_name,
    id: customerDebts[0].customer_id,
    totalDebts: customerDebts.length,
    byCurrency: customerDebts.reduce((acc, d) => {
      if (!acc[d.currency]) acc[d.currency] = { amount: 0, paid: 0, remaining: 0 };
      acc[d.currency].amount += parseFloat(d.amount);
      acc[d.currency].paid += parseFloat(d.paid_amount || 0);
      acc[d.currency].remaining += parseFloat(d.remaining_amount || d.amount);
      return acc;
    }, {})
  } : null;

  return (
    <div style={styles.container}>
      <style>{`@media print { .no-print { display: none !important; } body { direction: rtl; } }`}</style>

      <div style={styles.navbar} className="no-print">
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar} className="no-print">
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        <div style={styles.content}>

          {/* نافذة التسديد */}
          {showPayModal && selectedDebt && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>💰 تسديد مديونية يدوي</h3>
                <div style={styles.modalDetails}>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>العميل</span>
                    <span style={styles.modalValue}>{selectedDebt.customer_name}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>إجمالي الدين</span>
                    <span style={{...styles.modalValue, color: '#c62828'}}>
                      {parseFloat(selectedDebt.amount).toLocaleString()} {selectedDebt.currency}
                    </span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>المتبقي</span>
                    <span style={{...styles.modalValue, color: '#c62828', fontSize: '18px', fontWeight: 'bold'}}>
                      {parseFloat(selectedDebt.remaining_amount || selectedDebt.amount).toLocaleString()} {selectedDebt.currency}
                    </span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>النوع</span>
                    <span style={{...styles.modalValue, color: selectedDebt.debt_type === 'receivable' ? '#2e7d32' : '#c62828'}}>
                      {selectedDebt.debt_type === 'receivable' ? '📥 لنا (العميل يسدد لنا)' : '📤 علينا (نحن ندفع للعميل)'}
                    </span>
                  </div>
                </div>
                <form onSubmit={handlePay}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>المبلغ المدفوع</label>
                    <input style={styles.input} type="number" value={payForm.amount}
                      onChange={e => setPayForm({...payForm, amount: e.target.value})}
                      placeholder={`المتبقي: ${parseFloat(selectedDebt.remaining_amount || selectedDebt.amount).toLocaleString()}`}
                      required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>ملاحظات التسديد</label>
                    <textarea style={{...styles.input, height: '80px', resize: 'vertical'}}
                      value={payForm.notes}
                      onChange={e => setPayForm({...payForm, notes: e.target.value})}
                      placeholder="مثال: استلمت نقداً في المكتب / جاء شخص ودفع نيابة عن العميل..." />
                  </div>
                  <div style={styles.modalButtons}>
                    <button style={styles.payModalBtn} type="submit" disabled={loading}>
                      {loading ? 'جاري التسديد...' : '💰 تأكيد التسديد'}
                    </button>
                    <button style={styles.cancelBtn} type="button"
                      onClick={() => { setShowPayModal(false); setSelectedDebt(null); }}>
                      إلغاء
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* نافذة التمديد */}
          {showExtendModal && selectedDebt && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>📅 تمديد تاريخ الاستحقاق</h3>
                <div style={styles.modalDetails}>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>العميل</span>
                    <span style={styles.modalValue}>{selectedDebt.customer_name}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>المبلغ المتبقي</span>
                    <span style={{...styles.modalValue, color: '#c62828'}}>
                      {parseFloat(selectedDebt.remaining_amount || selectedDebt.amount).toLocaleString()} {selectedDebt.currency}
                    </span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>تاريخ الاستحقاق الحالي</span>
                    <span style={{...styles.modalValue, color: '#e65100'}}>
                      {selectedDebt.due_date ? new Date(selectedDebt.due_date).toLocaleDateString('ar-IQ') : 'غير محدد'}
                    </span>
                  </div>
                </div>
                <form onSubmit={handleExtend}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>التاريخ الجديد</label>
                    <input style={styles.input} type="date" value={extendForm.new_due_date}
                      onChange={e => setExtendForm({...extendForm, new_due_date: e.target.value})}
                      min={new Date().toISOString().split('T')[0]}
                      required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>سبب التمديد</label>
                    <textarea style={{...styles.input, height: '70px', resize: 'vertical'}}
                      value={extendForm.notes}
                      onChange={e => setExtendForm({...extendForm, notes: e.target.value})}
                      placeholder="مثال: تم الاتفاق على تمديد المدة لشهر إضافي..." />
                  </div>
                  <div style={styles.modalButtons}>
                    <button style={{...styles.payModalBtn, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}} type="submit" disabled={loading}>
                      {loading ? 'جاري التمديد...' : '📅 تأكيد التمديد'}
                    </button>
                    <button style={styles.cancelBtn} type="button"
                      onClick={() => { setShowExtendModal(false); setSelectedDebt(null); }}>
                      إلغاء
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* نافذة سجل التمديدات */}
          {showExtensionsModal && selectedDebt && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>📋 سجل التمديدات - {selectedDebt.customer_name}</h3>
                {extensions.length > 0 ? (
                  <div>
                    {extensions.map((e, i) => (
                      <div key={i} style={styles.extensionItem}>
                        <div style={styles.extensionRow}>
                          <span style={styles.extensionLabel}>من تاريخ</span>
                          <span style={{color: '#c62828', fontWeight: 'bold'}}>
                            {e.old_due_date ? new Date(e.old_due_date).toLocaleDateString('ar-IQ') : 'غير محدد'}
                          </span>
                        </div>
                        <div style={styles.extensionRow}>
                          <span style={styles.extensionLabel}>إلى تاريخ</span>
                          <span style={{color: '#2e7d32', fontWeight: 'bold'}}>
                            {new Date(e.new_due_date).toLocaleDateString('ar-IQ')}
                          </span>
                        </div>
                        {e.notes && (
                          <div style={styles.extensionRow}>
                            <span style={styles.extensionLabel}>السبب</span>
                            <span style={{color: '#666'}}>{e.notes}</span>
                          </div>
                        )}
                        <div style={styles.extensionRow}>
                          <span style={styles.extensionLabel}>بواسطة</span>
                          <span style={{color: '#1a237e', fontWeight: 'bold'}}>{e.extended_by_name}</span>
                        </div>
                        <div style={styles.extensionRow}>
                          <span style={styles.extensionLabel}>التاريخ والوقت</span>
                          <span style={{color: '#666', fontSize: '12px'}}>{formatDateTime(e.created_at)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{textAlign: 'center', padding: '30px', color: '#999'}}>
                    لا توجد تمديدات سابقة
                  </div>
                )}
                <button style={{...styles.cancelBtn, marginTop: '15px', width: '100%'}}
                  onClick={() => { setShowExtensionsModal(false); setSelectedDebt(null); }}>
                  إغلاق
                </button>
              </div>
            </div>
          )}

          {/* إحصائيات */}
          <div style={styles.statsGrid}>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
              <div style={styles.statIcon}>📋</div>
              <div style={styles.statNumber}>{debts.length}</div>
              <div style={styles.statLabel}>إجمالي المديونيات</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
              <div style={styles.statIcon}>📥</div>
              <div style={styles.statNumber}>{totalReceivable.toLocaleString()}</div>
              <div style={styles.statLabel}>إجمالي لنا</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #c62828, #e53935)'}}>
              <div style={styles.statIcon}>📤</div>
              <div style={styles.statNumber}>{totalPayable.toLocaleString()}</div>
              <div style={styles.statLabel}>إجمالي علينا</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
              <div style={styles.statIcon}>⚠️</div>
              <div style={styles.statNumber}>{overdueDebts.length}</div>
              <div style={styles.statLabel}>ديون متأخرة</div>
            </div>
          </div>

          {/* الديون المتأخرة */}
          {overdueDebts.length > 0 && (
            <div style={styles.alertCard} className="no-print">
              <h3 style={styles.alertTitle}>⚠️ ديون متأخرة - {overdueDebts.length} دين</h3>
              {overdueDebts.map((d, i) => (
                <div key={i} style={styles.alertItem}>
                  <span style={{fontWeight: 'bold', color: '#c62828'}}>{d.customer_name}</span>
                  <span>{parseFloat(d.remaining_amount || d.amount).toLocaleString()} {d.currency}</span>
                  <span style={{color: '#e65100', fontSize: '12px'}}>
                    استحق في: {new Date(d.due_date).toLocaleDateString('ar-IQ')}
                  </span>
                  <div style={{display: 'flex', gap: '5px'}}>
                    <button style={styles.alertPayBtn} onClick={() => openPayModal(d)}>💰 تسديد</button>
                    <button style={styles.alertExtendBtn} onClick={() => openExtendModal(d)}>📅 تمديد</button>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={styles.header} className="no-print">
            <h2 style={styles.pageTitle}>📋 إدارة المديونيات</h2>
            <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
              {showForm ? 'إلغاء' : '+ إضافة دين'}
            </button>
          </div>

          {/* البحث والفلاتر */}
          <div style={styles.searchCard} className="no-print">
            <div style={styles.searchRow}>
              <input style={styles.searchInput} value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="🔍 ابحث باسم العميل لعرض ملخص ديونه..." />
              <button style={styles.clearBtn} onClick={() => { setSearch(''); setFilterType('all'); setFilterStatus('all'); setFilterCurrency('all'); }}>
                مسح
              </button>
            </div>
            <div style={styles.filtersRow}>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>النوع</label>
                <select style={styles.filterSelect} value={filterType} onChange={e => setFilterType(e.target.value)}>
                  <option value="all">الكل</option>
                  <option value="receivable">📥 لنا</option>
                  <option value="payable">📤 علينا</option>
                </select>
              </div>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>الحالة</label>
                <select style={styles.filterSelect} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                  <option value="all">الكل</option>
                  <option value="pending">⏳ معلق</option>
                  <option value="partial">⚡ جزئي</option>
                  <option value="paid">✅ مسدد</option>
                </select>
              </div>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>العملة</label>
                <select style={styles.filterSelect} value={filterCurrency} onChange={e => setFilterCurrency(e.target.value)}>
                  <option value="all">الكل</option>
                  {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div style={styles.filterResult}>
                <span style={styles.filterResultText}>النتائج: <strong>{filteredDebts.length}</strong> من {debts.length}</span>
              </div>
            </div>
          </div>

          {/* ملخص العميل - يظهر فقط إذا كانت النتائج لعميل واحد */}
          {customerSummary && (
            <div style={styles.customerSummaryCard}>
              <div style={styles.customerSummaryHeader}>
                <div>
                  <h3 style={styles.customerSummaryName}>
                    👤 ملخص ديون: {customerSummary.name}
                  </h3>
                  <p style={{color: '#666', fontSize: '13px', margin: '3px 0'}}>
                    إجمالي {customerSummary.totalDebts} مديونية
                  </p>
                </div>
                <div style={{display: 'flex', gap: '10px'}} className="no-print">
                  <button style={styles.printSummaryBtn} onClick={handlePrint}>
                    🖨️ طباعة
                  </button>
                  <button style={styles.pdfSummaryBtn}
                    onClick={() => downloadCustomerDebtPDF(customerSummary.id, customerSummary.name)}
                    disabled={loadingPDF}>
                    {loadingPDF ? '⏳...' : '📥 PDF'}
                  </button>
                </div>
              </div>

              <div style={styles.currencySummaryGrid}>
                {Object.entries(customerSummary.byCurrency).map(([currency, data]) => (
                  <div key={currency} style={styles.currencySummaryItem}>
                    <div style={styles.currencySummaryCode}>{currency}</div>
                    <div style={styles.currencySummaryRow}>
                      <span style={styles.currencySummaryLabel}>إجمالي الدين</span>
                      <span style={{...styles.currencySummaryValue, color: '#1a237e'}}>
                        {data.amount.toLocaleString()}
                      </span>
                    </div>
                    <div style={styles.currencySummaryRow}>
                      <span style={styles.currencySummaryLabel}>إجمالي سدد</span>
                      <span style={{...styles.currencySummaryValue, color: '#2e7d32'}}>
                        {data.paid.toLocaleString()}
                      </span>
                    </div>
                    <div style={{...styles.currencySummaryRow, borderTop: '2px solid #e3f2fd', paddingTop: '8px', marginTop: '4px'}}>
                      <span style={{...styles.currencySummaryLabel, fontWeight: 'bold', color: '#333'}}>المتبقي</span>
                      <span style={{...styles.currencySummaryValue, color: data.remaining > 0 ? '#c62828' : '#2e7d32', fontSize: '18px', fontWeight: 'bold'}}>
                        {data.remaining.toLocaleString()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {showForm && (
            <div style={styles.formCard} className="no-print">
              <h3 style={styles.formTitle}>إضافة مديونية جديدة</h3>
              <form onSubmit={handleSubmit}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العميل</label>
                    <select style={styles.input} value={form.customer_id}
                      onChange={e => setForm({...form, customer_id: e.target.value})} required>
                      <option value="">-- اختر العميل --</option>
                      {customers.map(c => (
                        <option key={c.id} value={c.id}>{c.name} - {c.phone}</option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>نوع المديونية</label>
                    <select style={styles.input} value={form.type}
                      onChange={e => setForm({...form, type: e.target.value})}>
                      <option value="receivable">📥 لنا (العميل يدين لنا)</option>
                      <option value="payable">📤 علينا (نحن ندين للعميل)</option>
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>المبلغ</label>
                    <input style={styles.input} type="number" value={form.amount}
                      onChange={e => setForm({...form, amount: e.target.value})}
                      placeholder="0" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العملة</label>
                    <select style={styles.input} value={form.currency}
                      onChange={e => setForm({...form, currency: e.target.value})}>
                      {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>تاريخ الاستحقاق</label>
                    <input style={styles.input} type="date" value={form.due_date}
                      onChange={e => setForm({...form, due_date: e.target.value})} />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>ملاحظات</label>
                    <input style={styles.input} value={form.notes}
                      onChange={e => setForm({...form, notes: e.target.value})}
                      placeholder="أي ملاحظات" />
                  </div>
                </div>
                <button style={styles.submitBtn} type="submit" disabled={loading}>
                  {loading ? 'جاري الحفظ...' : '💾 حفظ المديونية'}
                </button>
              </form>
            </div>
          )}

          {/* جدول المديونيات */}
          <div style={styles.tableCard}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHead}>
                  <th style={styles.th}>العميل</th>
                  <th style={styles.th}>النوع</th>
                  <th style={styles.th}>المبلغ</th>
                  <th style={styles.th}>المتبقي</th>
                  <th style={styles.th}>المسدد</th>
                  <th style={styles.th}>العملة</th>
                  <th style={styles.th}>الاستحقاق</th>
                  <th style={styles.th}>ملاحظات</th>
                  <th style={styles.th}>الحالة</th>
                  <th style={styles.th}>إجراءات</th>
                </tr>
              </thead>
              <tbody>
                {filteredDebts.map((d, i) => {
                  const status = getStatusText(d.status);
                  const type = getTypeText(d.debt_type);
                  const isOverdue = d.due_date && new Date(d.due_date) < new Date() && d.status !== 'paid';
                  return (
                    <tr key={d.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{d.customer_name || '-'}</td>
                      <td style={{...styles.td, color: type.color, fontWeight: 'bold'}}>{type.text}</td>
                      <td style={styles.td}>{parseFloat(d.amount).toLocaleString()}</td>
                      <td style={{...styles.td, color: '#c62828', fontWeight: 'bold'}}>
                        {parseFloat(d.remaining_amount || d.amount).toLocaleString()}
                      </td>
                      <td style={{...styles.td, color: '#2e7d32'}}>
                        {parseFloat(d.paid_amount || 0).toLocaleString()}
                      </td>
                      <td style={styles.td}>{d.currency}</td>
                      <td style={{...styles.td, color: isOverdue ? '#c62828' : '#333', fontWeight: isOverdue ? 'bold' : 'normal'}}>
                        {d.due_date ? new Date(d.due_date).toLocaleDateString('ar-IQ') : '-'}
                        {isOverdue && <span style={{fontSize: '10px', display: 'block', color: '#c62828'}}>⚠️ متأخر</span>}
                      </td>
                      <td style={{...styles.td, fontSize: '12px', color: '#666'}}>{d.notes || '-'}</td>
                      <td style={styles.td}>
                        <span style={{...styles.statusBadge, background: status.bg, color: status.color}}>
                          {status.text}
                        </span>
                      </td>
                      <td style={styles.td} className="no-print">
                        <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap'}}>
                          {d.status !== 'paid' && (
                            <button style={styles.payBtn} onClick={() => openPayModal(d)}>
                              💰 تسديد
                            </button>
                          )}
                          {d.status !== 'paid' && (
                            <button style={styles.extendBtn} onClick={() => openExtendModal(d)}>
                              📅 تمديد
                            </button>
                          )}
                          <button style={styles.historyBtn} onClick={() => openExtensionsModal(d)}>
                            📋 سجل
                          </button>
                          <button style={styles.deleteBtn} onClick={() => handleDelete(d.id)}>
                            🗑️
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filteredDebts.length === 0 && <div style={styles.empty}>لا توجد نتائج</div>}
          </div>

        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', marginBottom: '20px' },
  statCard: { borderRadius: '12px', padding: '20px', color: 'white', textAlign: 'center' },
  statIcon: { fontSize: '24px', marginBottom: '8px' },
  statNumber: { fontSize: '24px', fontWeight: 'bold', marginBottom: '5px' },
  statLabel: { fontSize: '12px', opacity: 0.9 },
  alertCard: { background: '#fff3e0', border: '2px solid #e65100', borderRadius: '12px', padding: '20px', marginBottom: '20px' },
  alertTitle: { color: '#e65100', marginBottom: '10px', fontSize: '16px' },
  alertItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #ffe0b2', fontSize: '13px', flexWrap: 'wrap', gap: '8px' },
  alertPayBtn: { background: '#2e7d32', color: 'white', border: 'none', padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  alertExtendBtn: { background: '#1a237e', color: 'white', border: 'none', padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  addBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  searchCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  searchRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  searchInput: { flex: 1, padding: '10px 15px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  clearBtn: { background: '#666', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  filtersRow: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' },
  filterGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filterLabel: { fontSize: '12px', color: '#666', fontWeight: 'bold' },
  filterSelect: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterResult: { display: 'flex', alignItems: 'center' },
  filterResultText: { fontSize: '13px', color: '#666' },
  customerSummaryCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', borderRight: '4px solid #1a237e' },
  customerSummaryHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' },
  customerSummaryName: { color: '#1a237e', fontSize: '18px', marginBottom: '3px' },
  printSummaryBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  pdfSummaryBtn: { background: 'linear-gradient(135deg, #c62828, #b71c1c)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  currencySummaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' },
  currencySummaryItem: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', border: '1px solid #e3f2fd' },
  currencySummaryCode: { fontSize: '20px', fontWeight: 'bold', color: '#1a237e', marginBottom: '10px', borderBottom: '2px solid #e3f2fd', paddingBottom: '5px' },
  currencySummaryRow: { display: 'flex', justifyContent: 'space-between', marginBottom: '6px' },
  currencySummaryLabel: { fontSize: '12px', color: '#666' },
  currencySummaryValue: { fontSize: '14px', fontWeight: 'bold' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  formTitle: { marginBottom: '15px', color: '#1a237e' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: { marginBottom: '10px' },
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl', boxSizing: 'border-box' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '13px' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  statusBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' },
  payBtn: { background: '#2e7d32', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  extendBtn: { background: '#1a237e', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  historyBtn: { background: '#e65100', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  deleteBtn: { background: '#c62828', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: '16px', padding: '30px', width: '500px', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' },
  modalTitle: { color: '#1a237e', marginBottom: '20px', fontSize: '18px', borderBottom: '2px solid #e3f2fd', paddingBottom: '10px' },
  modalDetails: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', marginBottom: '20px' },
  modalRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e0e0e0' },
  modalLabel: { color: '#666', fontSize: '13px' },
  modalValue: { color: '#1a237e', fontWeight: 'bold', fontSize: '13px' },
  modalButtons: { display: 'flex', gap: '10px', marginTop: '20px' },
  payModalBtn: { flex: 1, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  cancelBtn: { flex: 1, background: '#f5f5f5', color: '#666', border: '1px solid #e0e0e0', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  extensionItem: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', marginBottom: '10px', borderRight: '4px solid #1a237e' },
  extensionRow: { display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: '13px' },
  extensionLabel: { color: '#666' },
};

export default Debts;